import { HttpService } from "@core/services/http.service.ts";
import { apiURL } from "@utils/environment.ts";
import { DynamicOptionPostDTO, DynamicOptionResponseDTO } from "@core/modeles/dynamicOption.model.ts";

export enum DynamicOptionCategory {
  ReferenceDocuments = 'REFERENCE_DOCUMENTS',
  InformationChannel = 'INFORMATION_CHANNEL',
  PartnershipType = 'PARTNERSHIP_TYPE',
  ConcernedBranches = 'CONCERNED_BRANCHES',
  LegalStatus = 'LEGAL_STATUS',
  AccusedInstitution = 'ACCUSED_INSTITUTION',
  Cluster = 'CLUSTER',
  IncidentLocation = 'INCIDENT_LOCATION',
  RelationshipWithVictim = 'RELATIONSHIP_WITH_VICTIM',
}

export interface DynamicOptionPayload {
  category: DynamicOptionCategory | string;
  labelOriginal: string;
  natureId?: number;
}

export interface DynamicOptionResponse {
  id: number;
  labelNormalized: string;
  labelOriginal: string;
  occurrenceCount: number;
  createdAt: string;
  standardCreatedAt: string;
  standard: boolean;
}

export class DynamicOptionService extends HttpService {
  private APIURL = apiURL;

  /**
   * POST /dynamic-option
   * Le backend attend un tableau (ArrayList) — on envoie 1 item enveloppé dans un tableau.
   */
  createDynamicOption(payload: DynamicOptionPostDTO): Promise<DynamicOptionResponseDTO[]> {
    this.urlAPI = this.APIURL + "/dynamic-option";
    return this.doPost<DynamicOptionResponseDTO[], DynamicOptionPostDTO[]>([payload]);
  }

  /**
   * POST /dynamic-option (alias pour externalAgentForm)
   */
  addOption(payload: DynamicOptionPayload): Promise<DynamicOptionResponse[]> {
    this.urlAPI = this.APIURL + "/dynamic-option";
    return this.doPost<DynamicOptionResponse[], DynamicOptionPayload[]>([payload]);
  }

  /**
   * GET /dynamic-option/category/{category}
   * Retourne toutes les options dynamiques d'une catégorie (standard=true ou toutes).
   */
  getByCategory(category: string): Promise<DynamicOptionResponseDTO[]> {
    this.urlAPI = this.APIURL + "/dynamic-option/category/" + category;
    return this.doGet<DynamicOptionResponseDTO[]>();
  }

  /**
   * GET /dynamic-option/category/{category} (alias pour externalAgentForm)
   */
  getOptionsByCategory(category: DynamicOptionCategory | string): Promise<DynamicOptionResponse[]> {
    this.urlAPI = this.APIURL + "/dynamic-option/category/" + category;
    return this.doGet<DynamicOptionResponse[]>();
  }
}
